import { render } from "./FenXi.vue?vue&type=template&id=50ee3a96&scoped=true"
import script from "./FenXi.vue?vue&type=script&lang=js"
export * from "./FenXi.vue?vue&type=script&lang=js"

import "./FenXi.vue?vue&type=style&index=0&id=50ee3a96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ee3a96"]])

export default __exports__